module.exports = __webpack_public_path__ + "static/img/st-2.3a5a4b7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/st-2.jpg
 ** module id = 586
 ** module chunks = 2
 **/